import { InventoryEventTabs } from 'src/components/Listings/InventoryEventPage/InventoryEventTabs';
import { TabWithStarIcon } from 'src/components/Listings/InventoryEventPage/TabWithStarIcon';
import { PurchaseEventTabs } from 'src/components/Purchases/PurchaseEventPage/PurchaseEventPage';
import { SaleEventTabs } from 'src/components/Sales/SaleEventPage/SaleEventPage';
import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import * as Tabs from 'src/core/ui/Tabs';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './EventHeader.css';

type NavTabItem<
  T extends InventoryEventTabs | PurchaseEventTabs | SaleEventTabs,
> = {
  value: T;
  contentId: ContentId;
};

export const EventHeaderNavTabs = <
  T extends InventoryEventTabs | PurchaseEventTabs | SaleEventTabs,
>({
  defaultTab,
  activeTab,
  setActiveTab,
  onUpdateDefaultTab,
  tabs,
}: {
  activeTab: T;
  defaultTab?: T;
  setActiveTab: (value: T) => void;
  onUpdateDefaultTab: (tab: T) => void;
  tabs: NavTabItem<T>[];
}) => {
  return (
    <Tabs.Root
      value={activeTab}
      onValueChange={(value) => {
        setActiveTab(value as T);
      }}
      className={styles.tabsSection}
    >
      <Tabs.List
        rootClassName={styles.tabsList}
        style={{ padding: `0 ${vars.spacing.sm}` }}
        showScrollEdges={false}
      >
        {tabs.map(({ value, contentId }) => (
          <Tabs.Trigger value={value} key={value}>
            <TabWithStarIcon
              onIconClick={onUpdateDefaultTab}
              defaultTab={defaultTab}
              tabType={value}
            >
              <Content id={contentId} />
            </TabWithStarIcon>
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  );
};
